export const realtorData = {
  email: 'amsu.propiedades@unne.cl',
  phone:'934290958'
};
